// extracted by mini-css-extract-plugin
export var container = "_nr-0";
export var dotAnimation = "_nr-2";
export var dotsLoading = "_nr-1";